<template>
  <div style="display: inline;">
    <yi_curd_table :name="$options.name" ref="yt" getUrl="/web/basic/material/price/update/log/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('caozuoshijian')">
            <yi_time_input :format="'yyyy-MM-dd HH:mm:ss'" :maxTime="31 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime" :start.sync="yt.conditions.begin" :end.sync="yt.conditions.end"></yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="yt.loading" @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>

            <el-button :loading="yt.loading" @click="clear()">{{ $t('chongzhi') }}</el-button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>
<script>
const date = new Date();
const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
const begin = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
export default {
  name: 'material_price_update_log',

  data() {
    return {
      columns: [
        {
          label: 'chanpinbianma',
          prop: 'material.code'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name'
        },
        {
          label: 'guige',
          prop: 'material.spec',
          width: 100
        },
        {
          label: 'caizhi',
          prop: 'material.ingredient',
          width: 100
        },
        {
          label: 'yanse',
          prop: 'material.color',
          width: 100
        },
        {
          label: '修改前价格',
          prop: 'updateBeforePrice',
          width: 100
        },
        {
          label: '修改后价格',
          prop: 'updateAfterPrice',
          width: 100
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'caozuoshijian',
          prop: 'createTime',
          type: 'time'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.workProcedureId = this.$attrs.workProcedureId;
      this.yt.conditions.begin = begin;
      this.yt.conditions.end = end;
      this.yt.conditions.orderBy = 'createTime asc';
      this.yt.get(1);
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions.materialIds = [];
      this.yt.conditions.end = end;
      this.yt.conditions.begin = begin;
      this.yt.conditions.orderBy = 'createTime asc';
      this.yt.get(1);
    }
  }
};
</script>
